import React, { useRef } from "react"
import { getCssSizeValue, getHtmlFromRedactorField, getItemType } from "@/utils/utils"
import { ScrollTrigger, useGSAP } from "@/utils/gsap"
import GridContainer from "@/components/common/GridContainer"
import Text from "@/components/common/Text"
import styled from "styled-components"
import { CONTENT_TYPES } from "@/constants"
import dynamic from "next/dynamic"
import { BREAKPOINTS } from "@/styles/themeSettings"
import Gallery from "@/components/gallery/Gallery"

const StyledSingleElementWrapper = styled.div`
	.pin-element {
		position: relative;
		z-index: 2;
	}

	.date {
		margin: ${getCssSizeValue(8, BREAKPOINTS.MOBILE)} 0;
		@media (min-width: ${({ theme }) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
			margin: ${getCssSizeValue(24)} 0;
		}
	}

	.image {
		margin: ${getCssSizeValue(24, BREAKPOINTS.MOBILE)} 0;
		@media (min-width: ${({ theme }) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
			margin: ${getCssSizeValue(40)} 0;
		}
	}

	.history-section {
		margin: ${getCssSizeValue(24, BREAKPOINTS.MOBILE)} 0;
		@media (min-width: ${({ theme }) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
			margin: ${getCssSizeValue(40)} 0;
		}
	}
`

const VariantImage = dynamic(() => import("@/components/common/VariantImage"))
const HistorySection = dynamic(() => import("@/components/PinnedHistoryModule/Section"))
const HighlightedHeading = dynamic(() => import("@/components/HighlightedHeading"))

const Item = ({ data }) => {
	const type = getItemType(data)
	switch (type) {
		case CONTENT_TYPES.VARIANT_IMAGE:
			return <VariantImage data={data} />
		case CONTENT_TYPES.HISTORY_SECTION:
			return <HistorySection data={data} />
		case CONTENT_TYPES.HIGHLIGHTED_HEADING_BLOCK:
			return <HighlightedHeading data={{ highlightedHeadingBlock: data }} />
		case CONTENT_TYPES.GALLERY:
			return <Gallery assets={data?.images || []} />
		default:
			return null
	}
}

const HistoryItem = ({ data, index = 0, isLastItem, onUpdate }) => {
	const id = data?.id || ""
	const date = data?.date || ""
	const item = data?.item || {}
	// const paddings = getPaddingsClassFromData({
	// 	paddings: {
	// 		top: PADDING.MEDIUM,
	// 		bottom: PADDING.MEDIUM,
	// 	},
	// })
	const description = getHtmlFromRedactorField(data?.description || "")
	const WrapperRef = useRef(null)
	const PinnedElementRef = useRef(null)

	useGSAP(
		() => {
			const { height } = PinnedElementRef.current.getBoundingClientRect()

			ScrollTrigger.create({
				trigger: WrapperRef.current,
				start: `top top+=12%`,
				end: `bottom-=${height} top+=12%`,
				pin: !isLastItem ? ".pin-element" : null,
				// markers: true,
				pinSpacing: false,
				invalidateOnRefresh: true,
				onUpdate: (props) => {
					onUpdate({ index, ...props })
				},
			})
		},
		{ scope: WrapperRef, dependencies: [index, isLastItem, onUpdate], revertOnUpdate: true },
	)

	return (
		<StyledSingleElementWrapper id={id} ref={WrapperRef}>
			<GridContainer className="pin-element" ref={PinnedElementRef}>
				<Text className="typo-borna typo-borna-66 col-desktop-4 col-mobile-8 date">{date}</Text>
			</GridContainer>
			<GridContainer className={`no-margin px-main indent-desktop-1 end-trigger text`}>
				<Text
					as="div"
					className="typo-strawford typo-strawford-45 col-desktop-9 col-mobile-8"
					dangerouslySetInnerHTML={description}
				/>
			</GridContainer>
			<Item data={item} />
		</StyledSingleElementWrapper>
	)
}

export default HistoryItem
